<h1 mat-dialog-title>Upload media</h1>

<mat-dialog-content class="scrollbar-width-thin">
  <div
    class="flex items-center justify-center aspect-2/1 border-2 border-dashed border-gray-200 rounded-lg transition-colors"
    [class.hover:border-gray-400]="!isUploading()"
    role="presentation"
    (drop)="handleDrop($event)"
    (dragover)="$event.preventDefault()"
  >
    <div
      class="flex flex-col items-center transition-opacity"
      [class.opacity-50]="isUploading()"
    >
      <div class="text-3xl">
        <mat-icon inline>upload_file</mat-icon>
      </div>
      <span class="text-gray-500"
        >Sleep en zet bestanden hier neer, of
        <span
          role="none"
          class="font-medium text-blue-500 underline"
          [class.hover:cursor-pointer]="!isUploading()"
          (click)="handleClick()"
          >blader</span
        >.</span
      >
    </div>
  </div>

  @if (hadInvalidUploadsFromExtension() && showExtensionWarning()) {
    <div
      class="bg-orange-100 border border-orange-200 text-orange-900 text-xs p-4 mt-4 mb-4 rounded-lg relative"
    >
      <button class="absolute top-[2px] right-[2px] cursor-pointer">
        <mat-icon class="shrink-0" (click)="hideWarning('extension')">close</mat-icon>
      </button>
      <div class="flex gap-2">
        <mat-icon class="shrink-0">warning</mat-icon>

        <span class="[text-box-trim:trim-both] leading-5 text-pretty"
          >Je mag alleen maar bestanden met de volgende extensies uploaden:
          {{ data.allowedExtensions.join(', ') }}
        </span>
      </div>
    </div>
  }

  @if (attemptedInvalidUploadSizes().length > 0 && showSizeWarning()) {
    <div
      class="bg-orange-100 border border-orange-200 text-orange-900 text-xs p-4 mt-4 mb-4 rounded-lg relative"
    >
      <button class="absolute top-[2px] right-[2px] cursor-pointer">
        <mat-icon class="shrink-0" (click)="hideWarning('filesize')">close</mat-icon>
      </button>
      <div class="flex gap-2 mb-[6px]">
        <mat-icon class="shrink-0">warning</mat-icon>

        <span class="[text-box-trim:trim-both] leading-5 text-pretty">
          Een of meerdere bestanden waren te groot en konden niet worden geupload.
        </span>
      </div>
      <app-short-table
        [dataSource]="attemptedInvalidUploadSizes()"
        [columns]="[
          {
            columnName: 'type',
            tableHeaderName: 'Bestandstype',
            valuePropertyName: 'type',
          },
          {
            columnName: 'maxSize',
            tableHeaderName: 'Maximale bestandsgrootte',
            valuePropertyName: 'maxSize',
          },
        ]"
        class="bg-orange-100 [text-box-trim:trim-both] leading-5 text-pretty"
      ></app-short-table>
    </div>
  }

  @if (hasFiles()) {
    <div class="text-sm font-medium pt-2 pb-4 mt-6">Bestanden</div>
    <div class="flex flex-col gap-2">
      @for (file of files(); track $index) {
        <div
          class="flex items-center p-3 border border-gray-200 rounded-lg relative overflow-hidden"
        >
          <div
            class="size-12 rounded-lg bg-gray-200 mr-2 text-xl/5 overflow-hidden relative shrink-0"
          >
            <app-avatar
              class="block size-full overflow-hidden relative"
              [src]="file.previewUrl"
            >
              <div
                class="text-xl bg-gray-200 text-gray-400 absolute inset-0 flex items-center justify-center opacity-100 transition-opacity"
              >
                <mat-icon>{{ getFileIcon(file.file) }}</mat-icon>
              </div>
            </app-avatar>
          </div>

          <div class="flex-auto overflow-hidden pr-4">
            <span class="block truncate">{{ file.file.name }}</span>
            <span class="text-xs text-gray-500"
              >{{ file.file.size | filesize }}

              @if (isUploading()) {
                / {{ file.progress.percentage() }}%
              }
            </span>
          </div>

          @if (!isUploading()) {
            @if (file.error) {
              <mat-icon
                class="mr-1"
                style="color: var(--mat-sys-error, #ef4444)"
                matTooltip="Upload mislukt. Probeer opnieuw."
              >error</mat-icon>
            }

            <button
              mat-icon-button
              class="ml-auto [--mdc-icon-button-state-layer-size:28px]"
              (click)="removeFile(file)"
            >
              <mat-icon>cancel</mat-icon>
            </button>
          }

          @if (file.uploading) {
            <mat-progress-bar
              class="absolute! inset-x-0 bottom-0"
              [mode]="file.progress.mode()"
              [value]="file.progress.percentage()"
            />
          }
        </div>
      }
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions>
  <button
    mat-button
    [disabled]="submitted() || isUploading()"
    [mat-dialog-close]="false"
  >
    Annuleren
  </button>

  <button
    mat-button
    [disabled]="!hasFiles() || submitted() || isUploading()"
    (click)="handleConfirm()"
  >
    Uploaden
  </button>
</mat-dialog-actions>
